export default function () {
  return {
    data: {},
    isContentLoading: false,
  };
}
